import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Necesito equipo especial o gimnasio?',
  answer: 'No. Todo se hace en casa en 5 minutos, sin equipo.'
}, {
  question: '¿Cuándo veré los primeros resultados?',
  answer: 'La mayoría siente un aumento de energía entre el día 3 y el día 5.'
}, {
  question: '¿Es seguro para mayores de 55 años?',
  answer: 'Sí, los movimientos son de bajo impacto y adaptables a cualquier nivel físico.'
}, {
  question: '¿Qué pasa si fallo un día?',
  answer: 'No pasa nada. Retoma el protocolo en la siguiente comida. La consistencia es más importante que la perfección.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-[#FDFAF6]" data-id="element-44">
      <div className="max-w-3xl mx-auto" data-id="element-45">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-46">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-4" data-id="element-47">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-48">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-2xl border border-[#F0FDF4] overflow-hidden shadow-sm" data-id="element-49">
              <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={openIndex === index} data-id="element-50">
                <span className="font-bold text-[#1A1A1A] text-lg pr-8" data-id="element-51">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-[#2D8C4E] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-52" />
              </button>

              <AnimatePresence data-id="element-53">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-54">
                    <div className="px-6 pb-5 text-gray-600 font-sans" data-id="element-55">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}